import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';

import { DateType } from '../../CommonTypes';
import ShoppingListPeriodQuery from './ShoppingListPeriodQuery';

const ShoppingListPeriodConnectorApollo = ({ children }) => {
  const { loading, error, data } = useQuery(ShoppingListPeriodQuery);

  const result = {
    loading,
    error,
  };

  if (error) {
    throw error;
  }

  if (!loading && data.me.shoppingList && data.me.shoppingList.__typename === 'UserShoppingList') {
    result.period = data.me.shoppingList.period;
  }

  return children(result);
};

ShoppingListPeriodConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
  period: PropTypes.shape({
    start: DateType.isRequired,
    end: DateType.isRequired,
  }),
};

ShoppingListPeriodConnectorApollo.defaultProps = {
  period: undefined,
};

export default ShoppingListPeriodConnectorApollo;
